'use strict'

/*{
    type:'icon--not-found',
    src:'ic-register-result.svg'
}*/

class Failed {

    constructor() {
        
    }

    static bodyCSS(){
        if(!$('body').hasClass('mobile-header-inverted')){
            $('body').addClass('mobile-header-inverted')
        }
        if(!$('body > header').hasClass('main-header--slim')){
            $('body > header').addClass('main-header--slim');
        }
    }

    static success(options) {
        Failed.bodyCSS();
        $('main[class="main"]').html('<section class="page page-success">\
            <div class="content">\
                <div class="container text-lg-center">\
                    ' + (options.icon ? '<span class="icon icon--success ' + options.icon.type + '"><img src="../public/img/icons/' + options.icon.src + '" alt="" /></span>' : '') + '\
                    ' + (options.title ? '<h1 class="heading-2 mb-4">' + options.title + '</h1>' : '') + '\
                    ' + (options.description ? '<p class="lead">' + options.description + '</p>' : '') + '\
                    ' + (options.link ? '<a href="' + options.link.href + '" class="text-link mt-4">' + options.link.title + '</a>' : '') + '\
                </div>\
            </div>\
        </section>');
    }

    static show(options) {
        Failed.bodyCSS();
        $('main[class="main"]').html('<section class="page page-error">\
            <div class="content">\
                <div class="container text-lg-center">\
                    ' + (options.icon ? '<span class="icon icon--error ' + options.icon.type + '"><img src="../public/img/icons/' + options.icon.src + '" alt="" /></span>' : '') + '\
                    ' + (options.title ? '<h1 class="heading-2 mb-4">' + options.title + '</h1>' : '') + '\
                    ' + (options.description ? '<p class="lead">' + options.description + '</p>' : '') + '\
                    ' + (options.link ? '<a href="' + options.link.href + '" class="text-link mt-4">' + options.link.title + '</a>' : '') + '\
                </div>\
            </div>\
        </section>');
    }
}

export default Failed;